import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: '#fff',
    borderRadius: '0.75rem',
    display: 'flex',
    alignItems: 'center',
    fontSize: theme.size.sm,
    marginBottom: '0.5rem',
    padding: '0.5rem',
    gap: '1rem',
    cursor: 'pointer'
  },

  info: {
    display: 'grid',
    gridTemplateColumns: 'auto auto minmax(0px, 1fr)',
    alignItems: 'center',
    gap: '0.5rem'
  },

  title: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  }
}))

export default useStyles
